import { tns } from 'tiny-slider';
var GalleryModal = /** @class */ (function () {
    function GalleryModal() {
        this.galleryModal = document.querySelector('#gallery-modal');
        this.closeModalButton = this.galleryModal.querySelector('[data-close-modal]');
        this.sliderCounter = this.galleryModal.querySelector('.image-slide-count');
        this.currentSlideWrapper = this.sliderCounter.querySelector('p span:first-child');
        this.totalSlidesWrapper = this.sliderCounter.querySelector('p span:last-child');
        this.closeMethodBound = this.closeMethod.bind(this);
        this.addEventListeners();
    }
    GalleryModal.prototype.addEventListeners = function () {
        var _this = this;
        this.closeModalButton.addEventListener('click', function () {
            _this.destroySlider();
        });
    };
    GalleryModal.prototype.closeMethod = function (event) {
        var target = event.target;
        if (!this.galleryModal.querySelector('.gallery-modal').contains(target)) {
            this.destroySlider();
            this.galleryModal.classList.remove('active');
            this.galleryModal.setAttribute('aria-hidden', 'true');
        }
    };
    GalleryModal.prototype.initSlider = function () {
        var _this = this;
        this.sliderContent = this.galleryModal.querySelector('.content-wrapper');
        this.slider = tns({
            container: this.sliderContent,
            items: 1,
            slideBy: 1,
            loop: false,
            autoplay: false,
            controls: true,
            nav: false,
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            //@ts-ignore
            prevButton: this.galleryModal.querySelector('.slide-toggle.previous'),
            //@ts-ignore
            nextButton: this.galleryModal.querySelector('.slide-toggle.next'),
        });
        // Set total count of slides
        this.totalSlidesWrapper.innerText = this.slider.getInfo().slideCount;
        // Set initial current slide
        this.currentSlideWrapper.innerText = String(this.slider.getInfo().index + 1);
        this.slider.events.on('transitionEnd', function (event) { return _this.currentSlideWrapper.innerText = String(_this.slider.getInfo().index + 1); });
        // Zoom in / zoom out effect
        var images = document.querySelectorAll('.zoomable-image');
        images.forEach(function (image) {
            image.addEventListener('click', function (e) {
                if (!image.classList.contains('zoomed')) {
                    var rect = image.getBoundingClientRect();
                    var offsetX = (e.clientX - rect.left) / rect.width;
                    var offsetY = (e.clientY - rect.top) / rect.height;
                    image.style.transformOrigin = "".concat(offsetX * 100, "% ").concat(offsetY * 100, "%");
                    image.classList.add('zoomed');
                }
                else {
                    image.classList.remove('zoomed');
                }
            });
        });
        document.addEventListener('click', this.closeMethodBound);
    };
    GalleryModal.prototype.destroySlider = function () {
        //this.slider.destroy();
        this.slider = null;
        this.sliderContent.innerHTML = '';
        document.removeEventListener('click', this.closeMethodBound);
    };
    return GalleryModal;
}());
export default GalleryModal;
